// Theme is a user preference, not a tenant setting: it lives in localStorage and falls back to
// the OS preference. The palette itself is defined in tokens.css ([data-theme='light']).

export type Theme = 'dark' | 'light'

const KEY = 'auditai-theme'

export function resolveInitialTheme(): Theme {
  try {
    const saved = localStorage.getItem(KEY)
    if (saved === 'light' || saved === 'dark') return saved
  } catch {
    /* private mode */
  }
  return typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: light)').matches
    ? 'light'
    : 'dark'
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement
  root.dataset.theme = theme
  // Makes native controls (scrollbars, inputs, date pickers) follow the theme.
  root.style.colorScheme = theme
  try {
    localStorage.setItem(KEY, theme)
  } catch {
    /* ignore */
  }
}

export function bootTheme(): Theme {
  const theme = resolveInitialTheme()
  applyTheme(theme)
  return theme
}
